import { useTranslation } from "react-i18next";
import { Form, Select, Modal } from "@renderbus/ui";
import { useGlobalStore } from "@/store/GlobalStore";
import { FormInstance, ModalProps } from "antd";
import { useTabStore } from "../store/tab-store";
import styled from "styled-components";
import InfoIcon from "@/assets/icons/common/tip-icon";

export function FreeCouponTransferModal({
  open,
  modalProps,
  form,
}: {
  open: boolean;
  modalProps: ModalProps;
  form?: FormInstance;
}) {
  const { t } = useTranslation("coupon");
  const { isSubAccount } = useGlobalStore();
  const { subAccountInfo, defaultSubAccount } = useTabStore();

  return (
    <Modal
      open={open}
      title={
        isSubAccount
          ? t("coupon_pages_get_way_transfer_to_main_account")
          : t("coupon_pages_get_way_transfer")
      }
      children={
        isSubAccount ? (
          <CouponTip>
            <InfoIcon />
            <span>{t("coupon_pages_coupon_transfer_to_user")}</span>
          </CouponTip>
        ) : (
          <CouponForm
            size={"large"}
            colon={false}
            form={form}
            labelAlign="left"
            layout={"vertical"}
            requiredMark={false}
            className={"renderbus-ui--form"}
          >
            <Form.Item
              key="destUserId"
              name="destUserId"
              label={t("coupon_pages_transfer_to_subuser")}
            >
              <Select
                allowClear={false}
                className="transfer-select"
                options={subAccountInfo}
                defaultValue={defaultSubAccount}
              />
            </Form.Item>
          </CouponForm>
        )
      }
      okText={t("coupon_modal_confirm_text")}
      cancelText={t("coupon_modal_cancel_text")}
      {...modalProps}
    />
  );
}

const CouponForm = styled(Form)`
  .ant-form-item-label > label {
    width: 100%;
  }
  .transfer-select .ant-select-selector {
    background-color: #2c2c31 !important;
  }
`;

const CouponTip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 100px;
  svg {
    width: 20px;
    height: 22px;
  }
`;
